"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _contextualSearchWidget = _interopRequireDefault(require("../ContextualSearchWidget/contextualSearchWidget.proptypes"));

var _constant2 = require("../constant");

var _default = {
  PropTypes: {
    data: _propTypes.object.isRequired,
    redirectUrl: _propTypes.string,
    onSubmit: _propTypes.func,
    viewport: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    environment: _propTypes.string,
    prefill: _propTypes.object,
    locale: _propTypes.string,
    currency: _propTypes.string,
    endpointConfig: _propTypes.object,
    closeSearchWidget: _propTypes.func,
    showContextualSearchWidget: _propTypes.bool,
    contextualConfig: _contextualSearchWidget.default.PropTypes,
    isOnlyApplyForHotel: _propTypes.bool,
    fireGtm: _propTypes.func,
    maxRangeDays: _propTypes.number,
    maxDays: _propTypes.number,
    onSubmitHandler: _propTypes.func,
    isApplyHotelList: _propTypes.bool,
    ageList: _propTypes.array,
    showBannerBottom: _propTypes.bool,
    bannerConfig: _propTypes.object
  },
  DefaultProps: {
    viewport: _constant2.DEVICE_TYPE.DESKTOP,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    environment: 'DEVELOPMENT',
    locale: 'en-gb',
    currency: 'MYR',
    showContextualSearchWidget: false,
    isOnlyApplyForHotel: false,
    isApplyHotelList: false,
    showBannerBottom: false
  }
};
exports.default = _default;